// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Overview_MarketingResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/overview/marketing
 *
 * Recalculated Marketing ROI per docs/new-dashboard-plan.md §3:
 * - investimento       : SUM(despesa_valor) WHERE despesa_categoria_id = 3
 *                        within the session filter date range. Stored in
 *                        the DB as reais (decimal); we project to int
 *                        centavos here for consistency with the rest of the
 *                        overview surface.
 * - novos_clientes_count : COUNT(clientes WHERE cliente_data_cadastro in
 *                        period AND cliente_franquia_id IN filter). Surfaced
 *                        as the denominator of CAC for transparency.
 * - cac                : investimento / novos_clientes_count. Fix for the
 *                        existing bug that used orçamentos_aprovados as the
 *                        denominator. Int centavos. 0 when no new clients.
 * - roi                : (receita_liquida - investimento) / investimento as
 *                        a basis-points-like ratio expressed as a percent
 *                        with two decimals stored as int *100 (e.g. 12.34%
 *                        => 1234). 0 when investimento is 0.
 * - pct_da_receita     : investimento / receita_liquida — same percent-*100
 *                        encoding. 0 when receita_liquida is 0.
 *
 * Subset quirk: only `Manutenção` exists in `config_despesas_categorias`
 * locally (no `Marketing` despesa_categoria_id=3 entries), so investimento
 * will read 0 against the test subset — this is expected, not a bug.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Overview_MarketingResponseDados {
investimento: number
novos_clientes_count: number
cac: number
roi: number
pct_da_receita: number
}

export type Overview_MarketingResponse = ApiResponse<Overview_MarketingResponseDados>;

registerResponseContract('Overview_MarketingResponse', {
  investimento:         { type: 'number',  required: true },
  novos_clientes_count: { type: 'number',  required: true },
  cac:                  { type: 'number',  required: true },
  roi:                  { type: 'number',  required: true },
  pct_da_receita:       { type: 'number',  required: true },
})
